import { Api } from './Api';

const ServiceApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    sliders: builder.query({
      query: () => '/home-sliders',
    }),
    generalData: builder.query({
      query: () => '/general-data',
    }),
    getNewProducts: builder.query({
      query: () => {
        return {
          url: '/new-products',
          method: 'GET',
        };
      },
      transformResponse: (response) => {
        return {
          data: response.data,
        };
      },
      providesTags: ['products'],
    }),
    categoriesWiseProducts: builder.query({
      query: (slug) => `/category-products/slug/${slug}`,
      // providesTags: ['products']
    }),
    childCategoryWiseProducts: builder.query({
      query: ({ id, slug }) => `/child-subcategory-products/${id}/${slug}`,
    }),
    searchWiseProducts: builder.query({
      query: (slug) => `/product-search/${slug}`,
      providesTags: ['products'],
    }),
    bottomBanner: builder.query({
      query: () => '/bottom-banners',
    }),
    productDetails: builder.query({
      query: ({ slug, id }) => {
        return {
          url: `/product/details/${id}/${slug}`,
          method: 'GET',
        };
      },
      providesTags: ['products'],
    }),
    getCategories: builder.query({
      query: () => {
        return {
          url: '/categories',
          method: 'GET',
        };
      },
      transformResponse: (response) => {
        return {
          data: response.data,
        };
      },
      providesTags: ['categories'],
    }),
    getSubCategories: builder.query({
      query: () => {
        return {
          url: '/sub-categories',
          method: 'GET',
        };
      },
      transformResponse: (response) => {
        return {
          data: response.data,
        };
      },
      providesTags: ['categories'],
    }),
    getCartProducts: builder.query({
      query: (ip) => `/get-cart-products/${ip}`,
      providesTags: ['carts'],
    }),
    countCartProducts: builder.query({
      query: (ip) => `/cart-products-count/${ip}`,
      providesTags: ['carts'],
    }),
    aboutUs: builder.query({
      query: () => '/about-us',
    }),
    privacyPolicy: builder.query({
      query: () => '/privacy-policy',
    }),
    termsCondition: builder.query({
      query: () => '/terms-conditions',
    }),
    refundPolicy: builder.query({
      query: () => '/refund-policy',
    }),
    paymentPolicy: builder.query({
      query: () => '/payment-policy',
    }),
    // mutation
    addToCardDetails: builder.mutation({
      query: ({ data, id }) => ({
        url: `/product/add-to-cart-checkout/${id}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['carts'],
    }),
    deleteCart: builder.mutation({
      query: (id) => ({
        url: `/delete-cart/${id}`,
        method: 'GET',
      }),
      invalidatesTags: ['carts'],
    }),
    addToHome: builder.mutation({
      query: ({ ip_address, id }) => ({
        url: `/product/add-to-cart/${id}`,
        method: 'POST',
        body: ip_address,
      }),
      invalidatesTags: ['carts'],
    }),
    placeOrder: builder.mutation({
      query: (data) => ({
        url: `/confirm-order`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['carts'],
    }),
    contactForm: builder.mutation({
      query: (data) => ({
        url: '/contact-store',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGeneralDataQuery,
  useBottomBannerQuery,
  useSlidersQuery,
  useGetNewProductsQuery,
  useCategoriesWiseProductsQuery,
  useChildCategoryWiseProductsQuery,
  useProductDetailsQuery,
  useSearchWiseProductsQuery,
  useGetCategoriesQuery,
  useAboutUsQuery,
  usePaymentPolicyQuery,
  usePrivacyPolicyQuery,
  useRefundPolicyQuery,
  useTermsConditionQuery,
  useContactFormMutation,
  useAddToCardDetailsMutation,
  useAddToHomeMutation,
  useCountCartProductsQuery,
  useGetCartProductsQuery,
  usePlaceOrderMutation,
  useGetSubCategoriesQuery,
  useDeleteCartMutation,
} = ServiceApi;
